'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function saveLocalStorageValue(key, value) {
    localStorage.setItem(key, JSON.stringify(value));
    return value;
}
function getLocalStorageValue(key) {
    const saved = localStorage.getItem(key);
    if (saved) {
        try {
            return JSON.parse(saved);
        }
        catch (e) {
            return saveLocalStorageValue(key, saved);
        }
    }
    return undefined;
}

exports.getLocalStorageValue = getLocalStorageValue;
exports.saveLocalStorageValue = saveLocalStorageValue;
